var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 48 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 50.6667C19.0493 50.6667 14.3014 48.7 10.8007 45.1993C7.29999 41.6986 5.33333 36.9507 5.33333 32C5.33333 27.0493 7.29999 22.3014 10.8007 18.8007C14.3014 15.3 19.0493 13.3333 24 13.3333C28.9507 13.3333 33.6986 15.3 37.1993 18.8007C40.7 22.3014 42.6667 27.0493 42.6667 32C42.6667 36.9507 40.7 41.6986 37.1993 45.1993C33.6986 48.7 28.9507 50.6667 24 50.6667ZM42.7467 17.04L46.5333 13.2533C45.3333 11.8933 44.1333 10.6667 42.7733 9.49333L38.9867 13.3333C34.8533 9.97333 29.6533 8 24 8C17.6348 8 11.5303 10.5286 7.02944 15.0294C2.52856 19.5303 0 25.6348 0 32C0 38.3652 2.52856 44.4697 7.02944 48.9706C11.5303 53.4714 17.6348 56 24 56C37.3333 56 48 45.2533 48 32C48 26.3467 46.0267 21.1467 42.7467 17.04ZM21.3333 34.6667H26.6667V18.6667H21.3333M32 0H16V5.33333H32V0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.850907076b895e87e5ab89ce5590a437.svg";
export { ForwardRef as ReactComponent };